import type { Session } from "./session.ts";

export const PRODUCT_CODES = ["onb", "wai", "wov", "sks", "lms", "wpm", "pbd"] as const;

export type ProductCode = (typeof PRODUCT_CODES)[number];

export function hasProduct(session: Session | null | undefined, product: ProductCode) {
    return !!session?.assignedProducts.includes(product);
}
